import React from 'react';

import TitleBar from 'shared/migration-components/title-bar';

import {Container} from './styles';
import Tabs, {TabProps} from 'shared/migration-components/tabs';
import {
  EditCompany,
  WorkPeriods,
  AccessControls,
  Distances,
  NeighborhoodPrices,
} from './components';
import useAccessControls from 'modules/access-controls/atoms/use-access-controls';

interface Props {
  activeTab?: string;
}

const CompanyDetails: React.FC<Props> = ({activeTab}) => {
  const {isAllowed, companyId} = useAccessControls();

  const tabs: TabProps[] = [
    {
      label: 'Editar empresa',
      content: <EditCompany />,
      hidden: !isAllowed('companies.findOne'),
    },
    {
      tab: 'working-periods',
      label: 'Horários de funcionamento',
      content: <WorkPeriods />,
      hidden: !isAllowed('companies.findOne'),
      createUrl: 'create',
    },
    {
      tab: 'access-controls',
      label: 'Controle de acesso',
      content: <AccessControls />,
      createUrl: 'create',
    },
    {
      tab: 'distances',
      label: 'Distâncias',
      content: <Distances />,
      createUrl: 'create',
    },
    {
      tab: 'neighborhood-prices',
      label: 'Bairros',
      content: <NeighborhoodPrices />,
      createUrl: 'create',
    },
  ];

  return (
    <Container>
      <TitleBar
        title="Detalhes da Empresa"
        backUrl={companyId ? undefined : '/settings/companies'}
      />
      <Tabs {...{activeTab, tabs}} />
    </Container>
  );
};

export default CompanyDetails;
